import { render } from "./DetailsColis.vue?vue&type=template&id=04abe9d4&ts=true"
import script from "./DetailsColis.vue?vue&type=script&lang=ts"
export * from "./DetailsColis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__